const PRODUCTION_API_BASE = 'https://y2i44jhb22.execute-api.sa-east-1.amazonaws.com/prd';
const LOCAL_API_BASE = 'http://localhost:3000/prd';

export function resolveApiBaseUrl(mode: string | undefined, configured?: string): string {
  const value = configured?.trim() || (mode === 'production' ? PRODUCTION_API_BASE : LOCAL_API_BASE);
  let url: URL;
  try { url = new URL(value); } catch { throw new Error('URL da API inválida.'); }
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || url.search || url.hash) {
    throw new Error('URL da API inválida.');
  }
  const host = url.hostname.toLowerCase();
  const loopback = host === 'localhost' || host.endsWith('.localhost') || host === '[::1]' || /^127\./.test(host);
  if (mode === 'production' && (url.protocol !== 'https:' || loopback)) {
    throw new Error('O build de produção exige uma API HTTPS pública.');
  }
  return value.replace(/\/+$/, '');
}
